import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-empty-state-description',
})
export class XpoEmptyStateDescription {}
